module.exports = __webpack_public_path__ + "assets/img/exhibitionPlatform.b55fa721.png";